<template>
	<div class="white-box">
		<h3 class="box-title">PROYECTOS NUEVOS</h3>
		<bar-chart :options="options" :chart-data="datacollection"></bar-chart>
	</div>
</template>
<script>
	import BarChart from './../../../../charts/basics/BarChart.vue';
	export default {
		props: ['user', 'isAuth'],
		components: {
			BarChart,
		},
		data () {
			return {
				data: null,
				labels: [],
				series: [],

				datacollection: null,

				chart: null,

				options: {
					responsive: true,
					legend: {
						display: false,
					},
					scales: {
						yAxes: [{
							ticks: {
								beginAtZero: true,
								callback: function (value) { if (Number.isInteger(value)) { return value; } },
								stepSize: 10
							}
						}]
					},
				},
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
				this.getData()
			},
			getData() {
				this.$http.get('admin/projects/charts/new/projects/per/month')
				.then(response => {
					this.data = response.body
					this.loadData()
				})
			},
			loadData() {
				var that = this
				var labels = []
				var series = []

				$.each(this.data, function(index, value) {
					var date = moment(index).format('MMMM')
					var month = that.$options.filters.ucfirst(date)
					labels.push(month)
					series.push(value)
				})

				this.labels = labels

				var data = {
					label: 'Proyectos',
					data: series
				}

				this.series = [data]

				this.datacollection = {
					labels: this.labels,
					datasets: this.series,
				}
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/projects/dashboard/views/charts/newProjectsPerMonth.vue